import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FooterService {
  private _isCollapsed = signal(false);

  get isCollapsed() {
    return this._isCollapsed.asReadonly();
  }

  toggleFooter() {
    this._isCollapsed.set(!this._isCollapsed());
  }

  setCollapsed(collapsed: boolean) {
    this._isCollapsed.set(collapsed);
  }
}